// extracted by mini-css-extract-plugin
export default {"mapLayout":"MapPage_mapLayout__WDCTQ","map":"MapPage_map__en-cG","sidebar":"MapPage_sidebar__3JaEQ"};